module.exports = __webpack_public_path__ + "img/LOGO CP.b86b0af0.png";